import { V1DiscountDetail } from '@/api/clients/ohip';

interface SearchResults {
  rooms: { availability: { discountDetail: V1DiscountDetail }[] }[];
}

export function resultsContainMembershipRate(
  results: SearchResults | undefined
) {
  return Boolean(
    results?.rooms.some((room) =>
      room.availability.some((rate) => rate.discountDetail.membershipRateCode)
    )
  );
}
